import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const DashboardLayout = () => {
  const userdetail = JSON.parse(localStorage.getItem("UserData"));
  const handleLogout = () => {
    localStorage.removeItem('loginTime')
    localStorage.removeItem('UserData')
  }
  return (
    <div className="dashboard-container d-flex">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          {/* <div className="avatar">
            <img
              className="avatar-img"
              src="https://via.placeholder.com/80"
              alt="profile"
            />
          </div> */}
          <h6 className="username">{userdetail?.full_name}</h6>
          <p className="email">{userdetail?.email}</p>
          <hr className="mt-4"/>
        </div>
        <ul className="sidebar-nav">
          <li>
            <NavLink
              to="/dashboard"
              end
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              <i className="bi bi-speedometer2 me-2"></i> Your Listing
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/dashboard/create-ad"
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              <i className="bi bi-plus-square-fill me-2"></i> Add Your Ad
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/login"
              onClick={handleLogout}
              className={({ isActive }) => `nav-link text-danger ${isActive ? "active" : ""}`}
            >
              <i className="bi bi-box-arrow-right me-2"></i> Sign Out
            </NavLink>
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <main className="content flex-grow-1 p-4">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
